import React from "react";
import { useTranslation } from "react-i18next";
import ApplyFilterButton from "../../component/ApplyFilter";

const MyPackageFilters = ({
  filters,
  vendorOptions,
  dataOptions,
  validityOptions,
  onFilterChange,
  onApplyFilter,
  onClearFilters,
}) => {
  const { t } = useTranslation();

  return (
    <RowWrapper>
      <select
        value={filters.vendor}
        onChange={(event) => onFilterChange("vendor", event.target.value)}
        className="my-package-filter-control"
      >
        <option value="">All Vendors</option>
        {vendorOptions.map((vendor) => (
          <option key={vendor} value={vendor}>
            {vendor}
          </option>
        ))}
      </select>
      <select
        value={filters.status}
        onChange={(event) => onFilterChange("status", event.target.value)}
        className="my-package-filter-control"
      >
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="expired">Expired</option>
      </select>
      <select
        value={filters.data}
        onChange={(event) => onFilterChange("data", event.target.value)}
        className="my-package-filter-control"
      >
        <option value="">All Data</option>
        {dataOptions.map((data) => (
          <option key={data} value={data}>
            {parseFloat(data) > 0
              ? `${data} ${t("home.part22")}`
              : t("home.part33")}
          </option>
        ))}
      </select>
      <select
        value={filters.validity}
        onChange={(event) => onFilterChange("validity", event.target.value)}
        className="my-package-filter-control"
      >
        <option value="">All Validity</option>
        {validityOptions.map((validity) => (
          <option key={validity} value={validity}>
            {validity} {t("home.part21")}
          </option>
        ))}
      </select>
      <ApplyFilterButton onApply={onApplyFilter} />
      <button
        type="button"
        onClick={onClearFilters}
        className="my-package-clear-filter"
      >
        Clear
      </button>
    </RowWrapper>
  );
};

const RowWrapper = ({ children }) => (
  <div className="my-package-filter-panel">{children}</div>
);

export default MyPackageFilters;
